module.exports = __webpack_public_path__ + "img/scene9.dacf93fd.gif";